import { hasValue } from "../../utils/pacto-rebates-utils";
import { onlyNumbers } from "./admin-utils";

export const formatVariluxGoalsPayload = ({
	additionalPairsYear1,
	additionalPairsYear2,
	additionalPairsYear3
}) => {
	return {
		paresPrimeiroAno: onlyNumbers(additionalPairsYear1),
		paresSegundoAno: onlyNumbers(additionalPairsYear2),
		paresTerceiroAno: onlyNumbers(additionalPairsYear3)
	};
};

export const getVariluxGoalsSegmentationId = values => {
	return values.idSegmentation || values.segmentation;
};

export const formatVariluxGoalsResponse = variluxGoals => ({
	id: variluxGoals.id,
	idSegmentation: variluxGoals.idSegmentacao || "",
	segmentation: variluxGoals.identificacaoSegmentacao || "",
	additionalPairsYear1: variluxGoals.paresPrimeiroAno,
	additionalPairsYear2: variluxGoals.paresSegundoAno,
	additionalPairsYear3: variluxGoals.paresTerceiroAno,
	createdAt: variluxGoals.dataCriacao,
	updatedAt: variluxGoals.dataUltimaAtualizacao
});

export const validateVariluxGoalsPayload = values => {
	const errors = {};

	if (!hasValue(getVariluxGoalsSegmentationId(values))) {
		errors.segmentation = "Informe o tamanho do cliente.";
	}

	if (!hasValue(values.additionalPairsYear1)) {
		errors.additionalPairsYear1 = "Informe os pares adicionais do ano 1.";
	}

	if (!hasValue(values.additionalPairsYear2)) {
		errors.additionalPairsYear2 = "Informe os pares adicionais do ano 2.";
	}

	if (!hasValue(values.additionalPairsYear3)) {
		errors.additionalPairsYear3 = "Informe os pares adicionais do ano 3.";
	}

	return errors;
};